import LinkIcon from 'assets/ver2/icons/link-icon.svg';
import { DESKTOP_MIN_WIDTH } from 'constants';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import { ReferralContentTabStyled } from '../ReferralContentTab1';

const ReferralContentTab3 = ({ style = {} }) => {
  const { t } = useLang();

  const links = [
    {
      step: 1,
      content: 'label_referral_tab_3',
      href: `link_referral_term_and_condition`,
    },
  ];

  const renderLink = (link) => {
    return (
      <>
        <a href={t(link.href)}>{t(link.content)}</a>
        <img src={LinkIcon} width={24} height={24} />
      </>
    );
  };

  return (
    <ReferralContentTabStyled style={style}>
      <LinkContent>
        {links.map((l) => (
          <LinkWrap key={l.step}>{renderLink(l)}</LinkWrap>
        ))}
      </LinkContent>
    </ReferralContentTabStyled>
  );
};

const LinkContent = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    align-items: center;
  }
`;
const LinkWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0px;
  height: 24px;
  width: 100%;
  &:hover {
    opacity: 0.6;
  }

  & a {
    ${paragraphMixin};
    font-weight: 500;
    color: var(--ds-c-blue-hyperlink-default);
    text-decoration: none;
    text-transform: uppercase;
    margin: 0;
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    gap: 8px;
    justify-content: start;
  }
`;

export default ReferralContentTab3;
